// extracted by mini-css-extract-plugin
export default {"wrapper":"SLA3DPrintingForm_wrapper__UAboY","btn":"SLA3DPrintingForm_btn__txHjI"};